import { IndexApi } from "~/solidJs/pages/Index/data";
import { queryClient } from "~/solidJs/shared/api/queryClient";

/**
 * fetches and saves node definition data from backend to cache layer
 */
export function requestCloudNodeList() {
	return queryClient.fetchQuery(IndexApi.getFetchCloundNodeListOptions());
}
